import {Action} from '@reduxjs/toolkit'
import {persistReducer} from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import {put, takeLatest} from 'redux-saga/effects'
import {TenantFeatureList, UserModel} from '../models/UserModel'
import {getCurrentUser} from './AuthCRUD'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

export const actionTypes = {
  Login: '[Login] Action',
  Logout: '[Logout] Action',
  Register: '[Register] Action',
  UserRequested: '[Request User] Action',
  UserLoaded: '[Load User] Auth API',
  SetUser: '[Set User] Action',
  SetAccessToken: '[Set Access Token] Action',

  TenantFeaturesLoaded: '[Load Feature Flags] Feature Flags API',
  SetTenantFeatures: '[Set Feature Flags] Action',
}

const initialAuthState: IAuthState = {
  user: undefined,
  accessToken: undefined,
}

export interface IAuthState {
  user?: UserModel
  accessToken?: string
  tenantFeatureList?: TenantFeatureList
}

export const reducer = persistReducer(
  {storage, key: 'doora-auth', whitelist: ['user']},
  (state: IAuthState = initialAuthState, action: ActionWithPayload<IAuthState>) => {
    switch (action.type) {
      case actionTypes.Login: {
        const accessToken = action.payload?.accessToken
        return {accessToken, user: undefined}
      }

      case actionTypes.Register: {
        const accessToken = action.payload?.accessToken
        return {accessToken, user: undefined}
      }

      case actionTypes.Logout: {
        return initialAuthState
      }

      case actionTypes.UserLoaded: {
        const user = action.payload?.user
        return {...state, user}
      }

      case actionTypes.SetUser: {
        const user = action.payload?.user
        return {...state, user}
      }

      case actionTypes.SetAccessToken: {
        const accessToken = action.payload?.accessToken
        return {...state, accessToken}
      }

      case actionTypes.SetTenantFeatures: {
        const tenantFeatureList = action.payload?.tenantFeatureList
        return {...state, tenantFeatureList}
      }

      case actionTypes.TenantFeaturesLoaded: {
        const tenantFeatureList = action.payload?.tenantFeatureList
        return {...state, tenantFeatureList}
      }

      default:
        return state
    }
  }
)

export const actions = {
  login: (accessToken: string) => ({type: actionTypes.Login, payload: {accessToken}}),
  register: (accessToken: string) => ({
    type: actionTypes.Register,
    payload: {accessToken},
  }),
  logout: () => ({type: actionTypes.Logout}),
  requestUser: () => ({
    type: actionTypes.UserRequested,
  }),
  fulfillUser: (user: UserModel) => ({type: actionTypes.UserLoaded, payload: {user}}),
  setUser: (user: UserModel) => ({type: actionTypes.SetUser, payload: {user}}),
  setAccessToken: (accessToken: string) => ({
    type: actionTypes.SetAccessToken,
    payload: {accessToken},
  }),

  setTenantFeatures: (tenantFeatureList: TenantFeatureList) => ({
    type: actionTypes.SetTenantFeatures,
    payload: {tenantFeatureList},
  }),

  store: () => ({type: 'def'}),
}

export function* saga() {
  yield takeLatest(actionTypes.Login, function* loginSaga() {
    yield put(actions.requestUser())
  })

  yield takeLatest(actionTypes.Register, function* registerSaga() {
    yield put(actions.requestUser())
  })

  yield takeLatest(actionTypes.UserRequested, function* userRequested() {
    const {data: user} = yield getCurrentUser()
    yield put(actions.fulfillUser(user))
  })
}
